const AnywhereAccess = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
    >
      <path
        d="M33.2036 9H5.21588C4.79139 9 4.44531 9.36856 4.44531 9.82062V28.9106H33.9809V9.82062C33.9745 9.36856 33.6284 9 33.2039 9H33.2036ZM16.8783 9.77887H21.5344C21.5344 9.77887 21.8955 10.116 21.8905 10.4002C21.8856 10.676 21.5344 10.996 21.5344 10.996H16.8783C16.8783 10.996 16.5594 10.6689 16.5549 10.4002C16.5502 10.1228 16.8783 9.77887 16.8783 9.77887Z"
        fill="#B8CBFC"
      />
      <path
        d="M34.3597 30.2578H4.04678L2.02902 37.9561C1.96356 38.2063 2.00958 38.4706 2.1596 38.6725C2.30996 38.8813 2.53192 38.9993 2.77333 38.9993H35.6329C35.8746 38.9993 36.1031 38.8809 36.2466 38.6725C36.397 38.4637 36.4427 38.2066 36.3772 37.9561L34.3597 30.2578Z"
        fill="#B8CBFC"
      />
      <path
        d="M36.1397 26.972C36.1397 28.0911 35.2393 28.9986 34.1286 28.9986C33.0177 28.9986 32.1172 28.0911 32.1172 26.972C32.1172 25.8528 33.0176 24.9453 34.1286 24.9453C35.2393 24.9453 36.1397 25.8528 36.1397 26.972Z"
        fill="#2D65F2"
        fillOpacity="0.5"
      />
      <path
        d="M30.1235 23.1556L29.0125 21.8206C28.9325 21.726 28.895 21.602 28.9092 21.4784C28.9236 21.3549 28.9884 21.2429 29.088 21.1696C30.5724 20.1546 32.3247 19.6112 34.1187 19.6094C35.9128 19.6078 37.6662 20.1479 39.1524 21.1602C39.2522 21.2333 39.3171 21.345 39.3318 21.4686C39.3462 21.592 39.3092 21.716 39.2293 21.8107L38.1219 23.1493C37.9747 23.3321 37.7127 23.3703 37.5202 23.2371C36.5237 22.5363 35.3376 22.1611 34.1227 22.162C32.9075 22.1629 31.7221 22.5401 30.7267 23.2423C30.5337 23.3761 30.2714 23.3384 30.1235 23.1556Z"
        fill="#2D65F2"
        fillOpacity="0.5"
      />
      <path
        d="M26.8056 19.1521L25.6839 17.8044C25.6056 17.7112 25.5683 17.5901 25.5803 17.4687C25.5923 17.3472 25.6526 17.2359 25.7476 17.1601C28.1535 15.3088 31.0957 14.3042 34.1228 14.3008C37.15 14.2972 40.0946 15.2951 42.5044 17.1409C42.5993 17.2164 42.6601 17.3275 42.6723 17.4489C42.6845 17.5702 42.6474 17.6913 42.5696 17.7848L41.4526 19.1351C41.2949 19.323 41.0167 19.349 40.8275 19.1934C38.9173 17.6788 36.5567 16.8566 34.1262 16.8595C31.6956 16.8622 29.3368 17.69 27.4299 19.209C27.2412 19.3648 26.9635 19.3396 26.8056 19.1521Z"
        fill="#2D65F2"
        fillOpacity="0.5"
      />
      <path
        d="M44.7741 15.1193C44.6162 15.3083 44.3363 15.3331 44.148 15.1747C41.3213 12.8327 37.7742 11.5542 34.1147 11.5584C30.4549 11.5629 26.9108 12.8497 24.0899 15.1986C23.902 15.3573 23.6223 15.3331 23.464 15.1445L22.3401 13.794C22.2625 13.7013 22.2252 13.581 22.2363 13.4603C22.2476 13.3397 22.3064 13.2284 22.3995 13.1517C25.7228 10.4692 29.8533 9.00493 34.1113 9.00001C38.3697 8.99487 42.5031 10.4491 45.8327 13.124C45.9259 13.2005 45.9849 13.3113 45.9964 13.432C46.008 13.5527 45.9709 13.6729 45.8937 13.7659L44.7741 15.1193Z"
        fill="#2D65F2"
        fillOpacity="0.5"
      />
    </svg>
  );
};

export default AnywhereAccess;
